module.exports = __webpack_public_path__ + "img/scalability-2.453e62b4.png";